import { getActiveWorkspaceSlug } from "./workspaceStorage";

/**
 * Workspace enviado ao socket (newUser / users), alinhado ao legado Cockpit/Xpro.
 * Usa o slug pinado na aba (sessionStorage) para não misturar presença entre abas.
 */
export function getSocketWorkspace() {
  if (typeof window === "undefined") return "";
  try {
    const company = getActiveWorkspaceSlug();
    if (company) return `${company}.xpro.me`;
  } catch {
    /* ignore */
  }
  return window.location.host || "";
}
